<template>
  <div class="view-container">
    <sidebar />
    <div
      class="app-container"
      @click="$eventHub.$emit('hide-search', $event)"
    >
      <main-header />
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-12 content-inner">
              <transition
                appear
                mode="out-in"
                name="fadeIn"
              >
                <analytics-dashboard :campaign-id="campaignUniqueId" />
              </transition>
            </div>
          </div>
        </div>
        <loading-status />
      </div>
    </div>
  </div>
</template>
<script>
import AnalyticsDashboard from "../../components/analytics/Dashboard"

export default {
  components: {
    AnalyticsDashboard
  },
  props: {
    campaignUniqueId: {
      type: String,
      default: "latest"
    }
  }
}
</script>
